module.exports = ( Api, endpoints, $upload ) ->
  return {
    scope:
      request:  "=researchRequest"
      messages: "=requestMessages"

    link: ( scope, element, attrs ) ->

      notifyStarredDocChange = ->
        scope.$emit( 'Starred Doc changed' )

      scope.new_message = undefined
      scope.hideAddFile = true
      scope.files = []
      scope.uploading = false
      scope.uploaded = false
      scope.progressPercentage = 0

      scope.addFiles = (files) ->
        scope.files.push.apply scope.files, files

      scope.addMessage = () ->
        if scope.files?.length
          for file in scope.files
            scope.uploading = true
            scope.uploaded = false
            $upload.upload
              url: endpoints.ResearchRequestMessage,
              data:
                content: scope.new_message
                request: scope.request.id
                order: scope.messages.length
                field: 'value'
              file: file
            .progress (event) ->
              scope.progressPercentage = Math.round(100.0 * event.loaded / event.total)
            .success (message, status, headers, config) ->
              scope.messages.push message
              scope.uploading = false
              scope.uploaded = true
              scope.files = []
              notifyStarredDocChange()
            .error (data, status, headers, config) ->
              scope.error = true
              scope.uploading = false
              scope.uploaded = false
              $log.error 'oh snap!'
        else
          scope.uploading = true
          scope.uploaded = false
          message = new Api.ResearchRequestMessage
            content: scope.new_message
            request: scope.request.id
            order: scope.messages.length
          message.$save().then (message) ->
            scope.messages.push message
            scope.new_message = undefined
            scope.uploading = false
            scope.uploaded = true


      scope.completeRequest = () ->
        now = new Date()
        new Api.ResearchRequest( id: scope.request.id, completed_date: now.toISOString() ).$update()
        scope.request.completed_date = now.toISOString()

      scope.reopenRequest = () ->
        new Api.ResearchRequest( id: scope.request.id, completed_date: null ).$update()
        scope.request.completed_date = null

    template: require('./researchRequest.html')
  }
